export class CartResponse<T> {
  #CART_RESPONSE_DEFAULT_VALUE = () => ({}) as T;

  #response = this.#CART_RESPONSE_DEFAULT_VALUE();

  public get response() {
    return this.#response;
  }

  public set response(value: T) {
    this.#response = value;
    this.#onCartResponseUpdateFn?.();
  }

  public reset() {
    this.#response = this.#CART_RESPONSE_DEFAULT_VALUE();
    this.#onCartResponseUpdateFn?.();
  }

  #onCartResponseUpdateFn?: () => void;

  public onCartResponseUpdate(fn: () => void) {
    const isFunction = typeof fn === 'function';
    this.#onCartResponseUpdateFn = isFunction ? fn : undefined;
  }
}
